import React from 'react';

import Logo from './../images/logo.png';
import Chevron from './../images/chevron.png';

import { Link } from 'react-router-dom';

import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

import HomeImage from './../images/home-image.png';
import PremiumImage from './../images/premium-logo.png';
import { useUser } from './../hooks/useUser';

import { useFirebaseServices } from './../hooks/firebase-services.js';

import Spinner from './../components/spinner';

import { firebaseAnalytics } from './../firebase';
import { logEvent } from "firebase/analytics";


const PreTest = ({ priceAmount, currency, isPaid, setSignUpFlow }) => {

  const { user, loading } = useUser();
  const { checkout } = useFirebaseServices();
  const [purchaseButtonClicked, setPurchaseButtonClicked] = useState(false);


  const [testSelected, setTestSelected] = useState(isPaid ? true : false);


  if (priceAmount == null || currency == null) {

    return (<div> Loading...</div>);

  }



  const shortPrice = priceAmount.toString().slice(0, -2);
  const capsCurrency = currency.toString().toUpperCase();




  const TestOptions = ({ }) => {

    return (

      <div className="test-option-boxes">

        <div className="test-option-box">
          <div className="test-option-image-container" >
            <img className="test-option-image" src={HomeImage} alt="home-image" />
          </div>
          <div className="test-option-heading">
            Free test
          </div>

          <div>
            Gives you a basic overview of your Big Five personality dimensions.
          </div>


          <button className="button secondary" onClick={() => { 

             logEvent(firebaseAnalytics, 'Started free test');
            
            setTestSelected(true) }}>
            <div className="button-text">
              Take the test
            </div>
            <img className="button-icon" src={Chevron} alt="chevron" />
          </button>

        </div>


        {!isPaid ?

          <div className="test-option-box">
            <div className="test-option-image-container" >
              <img className="test-option-image" src={PremiumImage} alt="home-image" />
            </div>
            <div className="test-option-heading">
              Full test: $ {shortPrice}   {capsCurrency}
            </div>

            <div>
              Full test to give you the most in-depth results. You will gain access to your exact percentile score and additional information to help you understand your personality. 
            </div>

            {purchaseButtonClicked ? <Spinner />
              :

              <>



                <Link to="/premium-test">
                  <button className="button tertiary" onClick = {()=>{
                    logEvent(firebaseAnalytics, 'Read more premium test');
                  }}>

                    <div className="button-text">
                      Read more
                    </div>
                    <img className="button-icon" src={Chevron} alt="chevron" />

                  </button>
                </Link>


                {!user ?


                  <Link to="/profile">
                    <button className="button secondary" onClick={() => {
                      setSignUpFlow('register');
                    }}>
                      <div className="button-text">
                        Purchase
                      </div>
                      <img className="button-icon" src={Chevron} alt="chevron" />
                    </button>
                  </Link>

                  :


                  <button className="button secondary" onClick={() => {
                    setPurchaseButtonClicked(true);
                    checkout();
                  }}>
                    <div className="button-text">
                      Purchase
                    </div>
                    <img className="button-icon" src={Chevron} alt="chevron" />
                  </button>



                }



              </>
            }

          </div>

          : <></>
        }



      </div>
    );


  }



  const PreTestBox = ({ }) => {

    return (
      <div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >


          <div className="text-box">
            <div>
              Make sure you are in a quiet space where you know you will not be interrupted for the duration of the test. Try to answer each question honestly. Aim to not be overly flattering to yourself, nor overly self-critical. Do not take the test if you are overly tired or in an extreme emotional state. If you get stuck on a question, go with your instinct.
            </div>
            <div className="button-container">
              <Link to="/test">
                <button className="button secondary">
                  <div className="button-text">
                    Begin test
                  </div>
                  <img className="button-icon" src={Chevron} alt="chevron" />
                </button>
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    );


  }

  return (



    <div className="pre-test-container">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >

        <div className="heading-section">
          <div className="flex-divider">
            <img className="bigfive-logo" width="297" height="363" src={Logo} alt="logo" />
            <div>
              <div className="heading-section-title"> Select test type </div>
            </div>
          </div>
        </div>
        {(testSelected) ? < PreTestBox /> : <TestOptions />}

      </motion.div>

    </div>

  );
}

export default PreTest;
